// Pure helpers behind useModelCount, kept in their own import-free module so
// they're unit-testable without Jest having to resolve the hook's @/-aliased
// deps (axios / config/api), which it doesn't map.

// Validate + parse a sessionStorage-cached {models, providers} blob. Returns the
// object only when BOTH counts are numbers, else null — so a corrupt, partial,
// or non-JSON cache is ignored rather than rendering garbage (e.g. "undefined
// modèles").
export const parseCachedCount = (raw) => {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw);
    if (typeof v?.models === "number" && typeof v?.providers === "number") {
      return { models: v.models, providers: v.providers };
    }
    return null;
  } catch {
    return null;
  }
};

// Count concrete models + distinct providers from the /api/models response,
// excluding the "auto" routing pseudo-model (a meta-entry, not a real model).
// Returns {models, providers}, or null if the input isn't an array — so the
// caller keeps its fallback instead of rendering 0.
export const countFromModels = (data) => {
  if (!Array.isArray(data)) return null;
  const real = data.filter((m) => m && m.id !== "auto");
  const providers = new Set(real.map((m) => m.provider)).size;
  return { models: real.length, providers };
};
